<template lang="pug">
button.button.suus__text-button.suus__text-button--plain(
  v-bind="$attrs",
  v-on="$listeners",
  v-if="plain",
  :style="styleObject",
  text,
  :large="variant === 'large'",
  :small="variant === 'small'"
  :disabled="disabled"
) {{ label }}

v-btn.suus__text-button(
  v-bind="$attrs",
  v-on="$listeners",
  v-else,
  :color="setColor",
  :style="styleObject",
  text,
  :block="block",
  :large="variant === 'large'",
  :small="variant === 'small'"
  :disabled="disabled"
) {{ label }}
</template>

<script lang="ts">
import Vue from "vue"
import THEME from "../../constants/theme"
const { button } = THEME.typography

export default Vue.extend({
  name: "TextButton",
  props: {
    label: { type: String },
    color: { type: String, default: "textColor" },
    plain: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    variant: {
      type: String,
      default: "large",
    },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    setColor(): string | undefined {
      if (this.color === "primary") {
        return this.$vuetify.theme.themes.light.primary?.toString()
      }
      if (this.color === "textColor") {
        return this.$vuetify.theme.themes.light.textColor?.toString()
      }
      return this.color
    },
    styleObject(): object {
      return {
        ...button,
        fontSize: this.variant === "small" ? `${0.7}em` : button.fontSize,
        "--color": this.setColor,
        "--color-hover": this.$vuetify.theme.themes.light.primary,
      }
    },
  },
})
</script>

<style lang="sass" scoped>
$text-color: rgba(66, 66, 66, 1)
.suus__text-button
  &--plain
    text-transform: uppercase
    color: var(--color)
    &:hover
      color: var(--color-hover) !important
.suus__text-button
  color: var(--color)
.suus__text-button:hover
  color: var(--color-hover) !important
</style>
